<template>
  <div>
    <LvText
      v-if="title"
      h6
      bold
    >
      {{ $t(title) }}<LvText v-if="required" red>*</LvText>
    </LvText>
    <WsButton001
      class="mt-8"
      @click="$_onOpenPopup('popup')"
    >
      {{ $t(btnText) }}
    </WsButton001>
    <LvFlexBox v-if="value && value.length" class="mt-20">
      <WsButton001
        v-for="(item, itemIndex) in value"
        :key="itemIndex"
        outLine
        flatButton
        nonMinWidth
        trailingIcon="icon-cancel"
        :style="{'height': '32px'}"
        class="mb-4 mr-4"
        @click="$_onRemoveItem(item, true)"
      >
        {{ getText ? $t(getText(item)) : $t(item.name || item.text) }}
      </WsButton001>
    </LvFlexBox>
    <ValidationProvider
      v-slot="{ errors }"
      class="dropdown-wrap"
      :rules="rules"
    >
      <input
        type="hidden"
        :value="value"
      >
      <div
        v-if="errors.length > 0"
        class="invalid-text"
      >
        <i class="icon-warning invalid-icon" />
        <p
          v-for="(text_e,text_k) in errors"
          :key="text_k"
          class="text"
        >
          {{ $t(text_e) }}
        </p>
      </div>
    </ValidationProvider>
    <PopUp
      bottom
      :clickOutsideClose="false"
      :popUpActive="isActive.popup"
      @click="$_onClosePopup('popup')"
    >
      <LvText h6 bold class="mb-4">{{$t('已選擇')}}</LvText>
      <LvText v-if="!selectedList || !selectedList.length" h6>{{ ($t('尚未選取')) }}</LvText>
      <LvFlexBox v-else>
        <WsButton001
          v-for="(item, itemIndex) in selectedList"
          :key="itemIndex"
          outLine
          nonMinWidth
          trailingIcon="icon-cancel"
          :style="{'min-height': '32px'}"
          class="mb-4 mr-4"
          @click="$_onRemoveItem(item, false)"
        >
          {{ getText ? $t(getText(item)) : $t(item.name || item.text) }}
        </WsButton001>
      </LvFlexBox>
      <LvDataTable
        v-if="isActive.popup"
        ref="LvDataTable"
        :fetchUrl="fetchUrl"
        :setParams="setParams"
        :setListData="setListData"
        :columnHeader="columnHeader"
        :filterFieldTypes="filterFieldTypes"
        @data-click="$_onGoto($event)"
        @page-change="$_resetSelectAll"
        @fetch-data="$_isSelectAll($event)"
        @loading="$_onChangeIsLoading($event)"
      >
        <template v-slot:columnHeader="{columnHeaderItem}">
          <LvCheckbox
            v-if="columnHeaderItem.id === 'isChecked'"
            h3
            exclusive
            lightGray
            :value="true"
            :select="isSelectAll"
            @change="$_onToggleSelectAll($event)"
          />
        </template>
        <template v-slot:item="{rowItem, columnHeaderItem}">
          <LvCheckbox
            v-if="columnHeaderItem.id ==='isChecked'"
            h3
            exclusive
            lightGray
            :value="true"
            :select="$_isSelected(rowItem)"
            @change="$_onToggleCheck($event, rowItem)"
          />
        </template>
      </LvDataTable>
      <template v-slot:bottomBtn>
        <WsButton001
          outLine
          :isloading="isLoading.items"
          @click="$_onClosePopup('popup')"
        >
          {{ $t('取消') }}
        </WsButton001>
        <WsButton001
          :isloading="isLoading.items"
          @click="$_onSubmit()"
        >
          {{ $t('送出') }}
        </WsButton001>
      </template>
    </PopUp>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    btnText: {
      type: String,
      default: '新增',
    },
    value: {
      type: Array,
    },
    fetchUrl: {
      type: String,
    },
    setParams: {
      type: Function,
    },
    setListData: {
      type: Function,
    },
    columnHeader: {
      type: Array,
    },
    filterFieldTypes: {
      type: Array,
    },
    to: {
      type: String,
    },
    getText: {
      type: Function,
    },
    rules: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isLoading: {
        items: false
      },
      isActive: {
        popup: false,
      },
      isSelectAll: false,
      selectedList: [],
    };
  },
  computed: {
    _selectedIdList() {
      return this.selectedList.map(item => item.id);
    }
  },
  watch: {
    'isActive.popup': {
      handler(newVal) {
        if (newVal && this.value) return;
        this.selectedList = [...this.value];
      }
    },
    value: {
      handler() {
        this.selectedList = [...this.value];
      },
      immediate: true,
    }
  },
  methods: {
    $_onOpenPopup(type) {
      this.isActive[type] = true;
    },
    $_onClosePopup(type) {
      if (!this.isActive[type]) return;
      const actionList = {
        'popup': () => {
          this.selectedList = [];
          this.isSelectAll = false;
        },
      }
      this.isActive[type] = false;
      if (actionList[type]) actionList[type]();
    },
    $_onRemoveItem(item, isEmit) {
      const selectedList = isEmit ? [...this.value] : this.selectedList;
      const tarIndex = selectedList.findIndex(selectedItem => selectedItem.id === item.id);
      if (tarIndex >= 0) selectedList.splice(tarIndex, 1);
      if (isEmit) this.$emit('input', selectedList);
    },
    $_onGoto($event) {
      if (!this.to) return;
      const url = this.$router.resolve({
        path: `${this.to}/${$event.id}`,
      });
      window.open(url.href, '_blank');
    },
    $_resetSelectAll() {
      this.isSelectAll = false;
    },
    $_onToggleSelectAll($event) {
      const LvDataTable = this.$refs.LvDataTable;
      if (!LvDataTable) return;
      this.isSelectAll = $event;
      if (this.isSelectAll) {
        const notSelected = LvDataTable.listData.filter(data => !this._selectedIdList.includes(data.id));
        this.selectedList.push(...notSelected);
      } else {
        this.selectedList = this.selectedList.filter(item => !LvDataTable.listData.map(data => data.id).includes(item.id));
      }
    },
    $_onToggleCheck($event, rowItem) {
      const isChecked = $event;
      if (this.isSelectAll && !isChecked) this.isSelectAll = false;
      this.selectedList = isChecked
        ? [...this.selectedList, rowItem]
        : this.selectedList.filter(item => item.id !== rowItem.id);
    },
    $_onSubmit() {
      this.$emit('input', this.selectedList);
      this.$_onClosePopup('popup');
    },
    $_onChangeIsLoading($event) {
      if (!$event.type === 'content') return;
      this.isLoading.items = $event.value;
    },
    $_isSelected(rowItem) {
      return this._selectedIdList.includes(rowItem.id);
    },
    $_isSelectAll(listData) {
      const selectedInCurrentPage = listData.filter(data =>
        this.selectedList.some(item => item.id === data.id)
      );
      this.isSelectAll = selectedInCurrentPage.length === listData.length;
    }
  }
}
</script>